"use client";

import { UniversalLayout } from "@zapier/universal-layout";
import type { ComponentProps } from "react";

import { OneTrustCookieConsentScript } from "./OneTrustCookieConsentScript";

type Props = ComponentProps<typeof UniversalLayout>;

/**
 * Wrapper component that combines UniversalLayout with OneTrust cookie consent.
 *
 * OneTrust is co-located with UniversalLayout because:
 * 1. UniversalLayout's footer contains the "Manage cookies" button (ot-sdk-show-settings)
 * 2. OneTrust should only render where users can actually manage their cookie preferences
 * 3. Embedded pages don't use UniversalLayout and shouldn't show OneTrust
 *
 * @see INC-586 - Cookie consent was blocking embedded chatbot popups
 */
export function UniversalLayoutWithCookieConsent({
  children,
  ...props
}: Props) {
  return (
    <>
      <OneTrustCookieConsentScript />
      <UniversalLayout {...props}>{children}</UniversalLayout>
    </>
  );
}
